import type { LucideIcon } from 'lucide-react';
import {
  Building2,
  HardHat,
  Zap,
  Wrench,
  Gauge,
  Pencil,
  ShoppingCart,
  ShieldCheck,
  ClipboardCheck,
  PlugZap,
  Compass,
} from 'lucide-react';

/**
 * Presentation metadata for EPC department cards (icons + accent classes).
 * Department names/focusAreas now live in the backend EpcDepartmentMaster —
 * this maps a master's name to a look, with a neutral fallback for custom entries.
 */
export type DeptPresentation = { icon: LucideIcon; accent: string };

const BY_NAME_LOWER: Record<string, DeptPresentation> = {
  'civil & structural': { icon: HardHat, accent: 'from-amber-50 to-amber-100/60 border-amber-300/80 text-amber-900' },
  electrical: { icon: Zap, accent: 'from-yellow-50 to-yellow-100/60 border-yellow-300/80 text-yellow-900' },
  mechanical: { icon: Wrench, accent: 'from-sky-50 to-sky-100/60 border-sky-300/80 text-sky-900' },
  'instrumentation & control': {
    icon: Gauge,
    accent: 'from-indigo-50 to-indigo-100/60 border-indigo-300/80 text-indigo-900',
  },
  'design & engineering': {
    icon: Pencil,
    accent: 'from-violet-50 to-violet-100/60 border-violet-300/80 text-violet-900',
  },
  procurement: { icon: ShoppingCart, accent: 'from-teal-50 to-teal-100/60 border-teal-300/80 text-teal-900' },
  'qa / qc': {
    icon: ClipboardCheck,
    accent: 'from-emerald-50 to-emerald-100/60 border-emerald-300/80 text-emerald-900',
  },
  'hse / safety': { icon: ShieldCheck, accent: 'from-rose-50 to-rose-100/60 border-rose-300/80 text-rose-900' },
  commissioning: { icon: PlugZap, accent: 'from-cyan-50 to-cyan-100/60 border-cyan-300/80 text-cyan-900' },
  'planning & survey': { icon: Compass, accent: 'from-slate-50 to-slate-100/60 border-slate-300/80 text-slate-800' },
};

export function resolveDeptPresentation(name: string): DeptPresentation {
  return (
    BY_NAME_LOWER[name.trim().toLowerCase()] ?? {
      icon: Building2,
      accent: 'from-slate-50 to-slate-100/60 border-slate-300/80 text-slate-800',
    }
  );
}
